export const footerLangPosition = () => {
    const footerLangList = document.querySelector('.footer .footer-lang .toggle__hover-list');
    if (footerLangList.offsetHeight > 70) footerLangList.closest('.toggle__hover').classList.add('top');
};